import { io } from 'socket.io-client';
import { WEBSOCKET_URL } from './chatConfig';

/**
 * WebSocket сервис для агентов поддержки
 * Следует документации WebSocket Integration Guide
 */
class AgentWebSocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
  }

  /**
   * Подключение к WebSocket серверу (порт 3001 согласно документации)
   */
  connect() {
    if (this.socket) {
      this.socket.disconnect();
    }

    console.log('Connecting to WebSocket:', WEBSOCKET_URL);
    
    this.socket = io(WEBSOCKET_URL, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 5,
      timeout: 10000
    });

    return this.socket;
  }

  /**
   * Получить экземпляр сокета
   */
  getSocket() {
    return this.socket;
  }

  /**
   * Проверка подключения
   */
  isSocketConnected() {
    return this.socket && this.socket.connected;
  }

  /**
   * Отключение от WebSocket
   */
  disconnect() {
    if (this.socket) {
      console.log('Disconnecting from WebSocket');
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }
}

// Экспортируем singleton instance
const agentWebSocketService = new AgentWebSocketService();
export default agentWebSocketService;
